import script from "./ResultPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResultPopup.vue?vue&type=script&setup=true&lang=ts"

import "./ResultPopup.vue?vue&type=style&index=0&id=24d06f48&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24d06f48"]])

export default __exports__